import { createApp, markRaw } from "vue";
import { createPinia } from "pinia";
import VueGtag from "vue-gtag";

/* Ionic deps */
import { IonicVue } from "@ionic/vue";
/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";
/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";
/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

/* App files */
import App from "@/App.vue";
import router from "@/common/router";
import { i18n } from "@/common/i18n";
import storeService, { storage } from "@/common/services/storage";
import { LOCALE_STORAGE_KEY, AppLocale } from "@/common/store/locale.store";
import { GA_MEASUREMENT_ID } from "@/common/constants";

/* Theme variables */
import "@/common/theme/main.scss";

import "./registerServiceWorker";

const getBrowserLocale = (): AppLocale =>
  navigator.language.toLowerCase().startsWith("en") ? "en" : "es";

const pinia = createPinia().use(({ store }) => {
  store.$router = markRaw(router);
});

const app = createApp(App).use(IonicVue, { mode: "ios" }).use(router).use(i18n).use(pinia);

if (GA_MEASUREMENT_ID) {
  app.use(VueGtag, { bootstrap: false, config: { id: GA_MEASUREMENT_ID } });
}

Promise.all([storeService.isReady(), router.isReady()]).then(async () => {
  const savedLocale = (await storage.get(LOCALE_STORAGE_KEY)) as AppLocale | null;
  const initialLocale: AppLocale = savedLocale ?? getBrowserLocale();
  i18n.global.locale.value = initialLocale;

  app.mount("#app");
});
